import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal,NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { BreadcrumbService } from "src/app/services/breadcrumb";
@Component({
  selector: 'app-merchantlist',
  templateUrl: './merchantlist.component.html',
  styleUrls: ['./merchantlist.component.scss'],
  providers: [NgbModalConfig, NgbModal],

})
export class MerchantlistComponent implements OnInit {
  @ViewChild("WeekendModel") WeekendModel;
  @ViewChild("ViewmenuModel") ViewmenuModel;
  @ViewChild("DinerMenuModel") DinerMenuModel;

  breadcrumbItems: breadcrumbItem[] = [
    {
        label: 'Home',
        active: false,
        url: "/home",
    },
    {
      label: 'Merchant',
      active: false,
      url: "/merchants/merchant-home",
      // url:"/merchants"
    },
    {
      label: 'Merchant List',
      active: true,
      url:" ",
    },
  ];
  constructor(  private modalService: NgbModal,private BreadcrumbService: BreadcrumbService
    ) { }
  today:any
  page = 1;
  showeyes = false;


  ngOnInit(): void {
    this.BreadcrumbService.setValue(this.breadcrumbItems);

  }
  select(event: any) {
  
  }
  eyshowhide(){
this.showeyes =!this.showeyes
  }
  OpenWeekendModel() {
    this.modalService.dismissAll();
    this.modalService.open(this.WeekendModel, { size: 'lg merchantmodal', centered: true });
  }
  OpenViewmenuModel() {
    this.modalService.dismissAll();
    this.modalService.open(this.ViewmenuModel, { size: 'lg viewmodal', centered: true });
  }
  OpenDinerMenuModel() {
    this.modalService.dismissAll();
    this.modalService.open(this.DinerMenuModel, { size: 'lg DinerMenumodal', centered: true });
  }
}
